// ideas for illustrations : https://www.freepik.com/premium-vector/teacher-student-class_5024804.htm



export const schedules = [
	{
		name: "בוקר טוב",
		startTime: "6:30",
		endTime: "",
		color: "skyblue",
		order: "",
		imgURL: "https://www.pinclipart.com/picdir/big/123-1239799_sunshine-png-vector-download-sunshine-png-clipart.png",
		// iconURL: "https://image.flaticon.com/icons/png/512/169/169367.png"
		// iconURL: "https://cdn.iconscout.com/icon/free/png-256/sun-187-161346.png"
		iconURL: "https://static.vecteezy.com/system/resources/previews/001/192/822/non_2x/children-sun-png.png"
	},
	{
		name: "ארוחת בוקר",
		startTime: "6:50",
		endTime: "",
		color: "light-brown",
		order: "",
		imgURL : "https://pbs.twimg.com/media/DFH45hPV0AAI0L2.png",
		// iconURL: "https://icon-library.com/images/banana-icon-png/banana-icon-png-29.jpg"
		iconURL: "https://cdn4.iconfinder.com/data/icons/baby-shower-7/128/BABY_FOOD-512.png"
	},
	{
		name: "לצחצח שיניים",
		startTime: "7:10",
		endTime: "",
		color: "pink",
		order: "",
		// imgURL : "https://i5.walmartimages.com/asr/c75ddbed-5fd7-476d-8d23-a16152465947_1.3abed1cc2fa5e3be0468ea27b5f16bf2.png"        ,
		imgURL : "https://i.pinimg.com/originals/93/96/1b/93961bb8b4cf6691e98d7640fc772128.png"        ,
		iconURL: "https://cdn4.iconfinder.com/data/icons/dental-outline/512/toothbrush_1-512.png"
	},
	{
		name: "להתלבש",
		startTime: "7:20",
		endTime: "",
		color: "yellow",
		order: "",
		imgURL : "https://images.twinkl.co.uk/tr/image/upload/illustation/Girl-and-Boy-Changing---Clothes-Getting-Dressed-Putting-on-Shoes-Open-Eyes-KS1.png",
		iconURL: "https://icons.iconarchive.com/icons/iconsmind/outline/512/Womans-Underwear-2-icon.png"
	},
	{
		name: "הולכים לגן",
		startTime: "7:30",
		endTime: "",
		color: "yellow",
		order: "",
		imgURL : "https://i.pinimg.com/originals/16/69/0a/16690a5176de797817e1b9042e1b54d2.png",
		iconURL: "https://www.pngrepo.com/download/199651/classroom-kindergarten.png"
	},
	{
		name: "שיעור",
		startTime: "8:30",
		endTime: "",
		color: "orange",
		order: "",
		imgURL : "https://www.clipartkey.com/mpngs/m/31-316772_clipart-library-library-boards-rectangle-whiteboard-whiteboard.png"        ,
		iconURL: "https://www.vippng.com/png/full/306-3068529_png-file-svg-whiteboard-icon-png-transparent.png"
	},
	{
		name: "פעילות",
		startTime: "9:00",
		endTime: "",
		color: "red",
		order: "",
		imgURL : "https://www.pngitem.com/pimgs/m/113-1130879_hd-cartoon-kids-activity-school-activities-clipart-hd.png"        ,
		// iconURL: "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTmKE2f8gRNKw4hyDLup_7wC3CwmkxjUQgkEA&usqp=CAU"
		iconURL: "https://freepikpsd.com/wp-content/uploads/2019/10/activities-icon-png-3.png"
	},

	
	{
		name: "ארוחת צהריים",
		startTime: "12:30",
		endTime: "",
		color: "light-brown",
		order: "",
		imgURL : "https://img.pngio.com/-students-at-lunch-png-413_237.png",
		// iconURL: "https://cdn4.iconfinder.com/data/icons/baby-shower-7/128/BABY_FOOD-512.png"
		iconURL: "https://img.icons8.com/ios/452/dining-room.png"
	},
	{
		name: "סיפור",
		startTime: "13:00",
		endTime: "",
		color: "green",
		order: "",
		imgURL : "https://www.clipartmax.com/png/full/151-1511252_picture-of-children-reading-animated-parent-and-child-reading.png",
		iconURL: "https://images.vexels.com/media/users/3/140908/isolated/preview/bdc30bbe3c022a11e2d7fd0e642c61ae-open-book-icon-by-vexels.png"
	},
	{
		name: "שינת צהריים",
		startTime: "13:15",
		endTime: "",
		color: "darkblue",
		order: "",
		imgURL : "https://www.pngkey.com/png/full/112-1128925_bed-kids-bed-clipart.png",
		iconURL: "https://www.pngrepo.com/download/172450/moon-and-two-stars.png"
	},
	{
		name: "להתעורר",
		startTime: "15:15",
		endTime: "",
		color: "yellow",
		order: "",
		imgURL: "https://www.pinclipart.com/picdir/big/123-1239799_sunshine-png-vector-download-sunshine-png-clipart.png"      ,
		iconURL: "https://static.vecteezy.com/system/resources/previews/001/192/822/non_2x/children-sun-png.png"
	},
	{
		name: "שיעור",
		startTime: "15:30",
		// startTime: "22:30",
		endTime: "",
		color: "orange",
		order: "",
		imgURL : "https://www.clipartkey.com/mpngs/m/31-316772_clipart-library-library-boards-rectangle-whiteboard-whiteboard.png"        ,
		iconURL: "https://www.vippng.com/png/full/306-3068529_png-file-svg-whiteboard-icon-png-transparent.png"
	},
	{
		name: "פעילות",
		startTime: "16:00",
		endTime: "",
		color: "red",
		order: "",
		imgURL : "https://www.pngitem.com/pimgs/m/113-1130879_hd-cartoon-kids-activity-school-activities-clipart-hd.png",
		iconURL: "https://freepikpsd.com/wp-content/uploads/2019/10/activities-icon-png-3.png"
	},
	{
		name: "פלייטיים",
		startTime: "18:00",
		endTime: "",
		color: "green",
		order: "",
		imgURL: "https://www.firstclassbangkok.com/wp-content/uploads/child-playing-ipad-1.png",
		iconURL: "https://simpleicon.com/wp-content/uploads/ipad-landscape.png"
		
	},
	{
		name: "ארוחת ערב",
		startTime: "18:30",
		endTime: "",
		color: "light-brown",
		order: "",
		imgURL : "https://img.pngio.com/-students-at-lunch-png-413_237.png",
		iconURL: "https://img.icons8.com/ios/452/dining-room.png"
	},
	{
		name: "מקלחת",
		startTime: "19:15",
		endTime: "",
		color: "pink",
		order: "",
		imgURL : "https://thumbs.dreamstime.com/b/bubble-bath-yellow-rubber-duck-bird-toy-bathtub-soup-bubbles-cute-cartoon-baby-character-flat-design-white-background-vector-90803244.jpg",
		iconURL: "https://img.icons8.com/ios/452/shower.png"
	},
	{
		name: "סיפור",
		startTime: "19:40",
		endTime: "",
		color: "green",
		order: "",
		imgURL : "https://www.clipartmax.com/png/full/151-1511252_picture-of-children-reading-animated-parent-and-child-reading.png",
		iconURL: "https://images.vexels.com/media/users/3/140908/isolated/preview/bdc30bbe3c022a11e2d7fd0e642c61ae-open-book-icon-by-vexels.png"
	},
	{
		name: "לילה טוב",
		startTime: "20:00",
		endTime: "",
		color: "darkblue",
		order: "",       
		imgURL: "https://www.pngkey.com/png/full/112-1128925_bed-kids-bed-clipart.png",
		iconURL: "https://www.pngrepo.com/download/172450/moon-and-two-stars.png"
	},
]

// sort the schedules array
// schedules.sort(function (a, b) {
// 	let timeholderA = new Date();
// 	let timeholderB = new Date();
// 	timeholderA.setHours(a.startTime.split(':')[0]);
// 	timeholderA.setMinutes(a.startTime.split(':')[1]);
// 	timeholderB.setHours(a.startTime.split(':')[0]);
// 	timeholderB.setMinutes(a.startTime.split(':')[1]);
// 	console.log("timeholderA", timeholderA.getTime())
// 	console.log("timeholderB", timeholderB.getTime())
// 	return timeholderA.getTime() - timeholderB.getTime();
//   });



export const scheduleLoading = [
	{
			name: "",
			startTime: "",
			endTime: "",
			color: "light-gray",
			order: "0",
			imgURL: ""   
	}
]

// export const scheduleEmpty = [
// 	{
// 			name: "",
// 			startTime: "",
// 			endTime: "",
// 			color: "light-gray",
// 			order: ""    
// 	}
// ]